export default function AJAX_PHP() {
  return (
    <div>
      <h1>AJAX_PHP</h1>
      <p>This is the AJAX_PHP component.</p>
    </div>
  );
}